module.exports = __webpack_public_path__ + "img/html-evolution-15.45872e6b.jpg";